import React from "react";
import "./loading.css";

function LoadingTodos() {
  return (
    <div className="container-spinner">
      <div className="spinner"></div>
    </div>
  );
}

export { LoadingTodos };
